import { render, staticRenderFns } from "./AssetTypePropertyComponent.vue?vue&type=template&id=1f30797f&"
import script from "./AssetTypePropertyComponent.vue?vue&type=script&lang=ts&"
export * from "./AssetTypePropertyComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports